type AssistantLogin = {
  hasResourceRole?: (role: string) => boolean;
  tokenParsed?: { groups?: unknown };
};

// Navigation only: the server independently resolves the actor on every request.
export const adminAssistantOrganization = (login?: AssistantLogin): string | undefined => {
  if (!login?.hasResourceRole?.('admin') ||
    ['producer', 'store', 'superuser', 'quality', 'logistician'].some(role => login.hasResourceRole?.(role))) return undefined;
  const groups = login.tokenParsed?.groups;
  if (!Array.isArray(groups)) return undefined;
  const organizations = groups.filter((group): group is string => typeof group === 'string' && group.startsWith('/organizations/'));
  if (organizations.length !== 1 || !/^\/organizations\/apotea\/[a-zA-Z0-9_-]+$/.test(organizations[0])) return undefined;
  return organizations[0].slice('/organizations/'.length);
};
